import React from 'react';
import { Users, Award, Clock, MapPin } from 'lucide-react';
const About = () => {
  return <div className="w-full" data-id="element-149">
      {/* Hero Section */}
      <section className="bg-[#869CE4] text-white py-16" data-id="element-150">
        <div className="container mx-auto px-4" data-id="element-151">
          <div className="max-w-3xl mx-auto text-center" data-id="element-152">
            <h1 className="text-4xl font-bold mb-6" data-id="element-153">About Peakwave</h1>
            <p className="text-xl" data-id="element-154">
              Your trusted appliance repair specialists across the UK
            </p>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-155">
        <div className="container mx-auto px-4" data-id="element-156">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-157">
            <div data-id="element-158">
              <h2 className="text-3xl font-bold text-[#869CE4] mb-6" data-id="element-159">
                Who We Are
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-160">
                We specialise in fast, professional appliance repairs and
                service plans across the UK. From kitchens to living rooms, our
                trusted engineers are here to help. We offer fixed-price
                support, UK-based service, and peace of mind for every home.
              </p>
              <p className="text-gray-600 mb-4" data-id="element-161">
                At Peakwave, we understand how important your home appliances
                are to your daily life. That's why we've built our business
                around providing reliable, efficient service that you can count
                on. Our team of experienced engineers is committed to delivering
                exceptional repairs and maintenance, ensuring your appliances
                continue to function at their best.
              </p>
              <p className="text-gray-600" data-id="element-162">
                With our comprehensive service plans, you can enjoy complete
                peace of mind knowing that your essential appliances are
                protected against unexpected breakdowns and faults. We're proud
                to serve customers throughout the UK, bringing our expertise and
                professional service to homes across the nation.
              </p>
            </div>
            <div className="rounded-lg overflow-hidden shadow-xl" data-id="element-163">
              <img src="https://images.unsplash.com/photo-1556911220-bff31c812dba?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Friendly repair engineer with a customer" className="w-full h-full object-cover" data-id="element-164" />
            </div>
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className="py-16 bg-gray-50" data-id="element-165">
        <div className="container mx-auto px-4" data-id="element-166">
          <div className="text-center mb-12" data-id="element-167">
            <h2 className="text-3xl font-bold text-[#869CE4] mb-4" data-id="element-168">
              Our Values
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-169">
              At the heart of everything we do are our core values that guide
              our service and commitment to our customers.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-170">
            <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-171">
              <div className="w-16 h-16 bg-[#eef1fb] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-172">
                <Users className="text-[#869CE4]" size={28} data-id="element-173" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#869CE4]" data-id="element-174">
                Customer First
              </h3>
              <p className="text-gray-600" data-id="element-175">
                We prioritise our customers' needs and satisfaction in
                everything we do, ensuring a positive experience from start to
                finish.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-176">
              <div className="w-16 h-16 bg-[#eef1fb] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-177">
                <Award className="text-[#869CE4]" size={28} data-id="element-178" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#869CE4]" data-id="element-179">
                Quality Service
              </h3>
              <p className="text-gray-600" data-id="element-180">
                We are committed to delivering the highest standard of service,
                with attention to detail and professional excellence.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-181">
              <div className="w-16 h-16 bg-[#eef1fb] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-182">
                <Clock className="text-[#869CE4]" size={28} data-id="element-183" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#869CE4]" data-id="element-184">
                Reliability
              </h3>
              <p className="text-gray-600" data-id="element-185">
                You can count on us to be there when you need us, with prompt
                responses and dependable solutions for your appliances.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Service Area */}
      <section className="py-16" data-id="element-186">
        <div className="container mx-auto px-4" data-id="element-187">
          <div className="max-w-3xl mx-auto" data-id="element-188">
            <div className="text-center mb-12" data-id="element-189">
              <h2 className="text-3xl font-bold text-[#869CE4] mb-4" data-id="element-190">
                Our Service Area
              </h2>
              <p className="text-lg text-gray-600" data-id="element-191">
                Peakwave provides appliance repair and maintenance services
                across mainland UK.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-192">
              <div className="flex items-start mb-6" data-id="element-193">
                <MapPin className="text-[#f05a28] mr-4 mt-1 flex-shrink-0" size={24} data-id="element-194" />
                <div data-id="element-195">
                  <h3 className="text-xl font-semibold mb-2 text-[#869CE4]" data-id="element-196">
                    UK-Wide Coverage
                  </h3>
                  <p className="text-gray-600" data-id="element-197">
                    Our team of skilled engineers operates throughout England,
                    Scotland, and Wales, bringing expert appliance repair
                    services to homes across the nation. We aim to provide fast
                    response times, with most areas benefiting from our 24-48
                    hour appointment scheduling.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-198">
                <Clock className="text-[#f05a28] mr-4 mt-1 flex-shrink-0" size={24} data-id="element-199" />
                <div data-id="element-200">
                  <h3 className="text-xl font-semibold mb-2 text-[#869CE4]" data-id="element-201">
                    Response Times
                  </h3>
                  <p className="text-gray-600" data-id="element-202">
                    We understand that appliance breakdowns can be disruptive,
                    which is why we strive to offer prompt service appointments.
                    In most areas, we can schedule engineer visits within 24-48
                    hours of your call. For more remote locations, our team will
                    work with you to arrange the earliest possible appointment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-[#869CE4] text-white" data-id="element-203">
        <div className="container mx-auto px-4" data-id="element-204">
          <div className="max-w-3xl mx-auto text-center" data-id="element-205">
            <h2 className="text-3xl font-bold mb-6" data-id="element-206">
              Ready to Experience Our Service?
            </h2>
            <p className="text-xl mb-8" data-id="element-207">
              Protect your home appliances with our professional repair and
              maintenance plans.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-208">
              <a href="/" className="bg-white text-[#869CE4] px-8 py-3 rounded-md font-semibold text-center hover:bg-gray-100 transition" data-id="element-209">
                View Service Plans
              </a>
              <a href="/contact" className="bg-[#f05a28] text-white px-8 py-3 rounded-md font-semibold text-center hover:bg-[#d94e20] transition" data-id="element-210">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default About;